import { combineReducers } from 'redux';
import {
  IModerationAuditLogState,
  IModerationHotKeysState,
  IModerationMessagesState,
  IModerationPostsState,
  IModerationSearchState,
  IModerationUserState
} from '../comments-and-posts/state/types';
import { moderationReducer as messages } from '../comments-and-posts/state/reducers/moderation';
import { usersReducer as users } from '../comments-and-posts/state/reducers/users';
import { postsReducer as posts } from '../comments-and-posts/state/reducers/posts';
import { searchReducer as search } from '../comments-and-posts/state/reducers/search';
import { hotKeysReducer as hotKeys } from '../comments-and-posts/state/reducers/hot-keys';

import { auditReducer as audit } from '../comments-and-posts/state/reducers/audit';
import { IModeratedUsersState, moderatedUsersReducer as moderatedUsers } from '../users/state/reducer';
import { ILoadArticlesSliceState, loadArticlesReducer } from '../articles/reducers/loadArticlesSlice';
import { restrictedWordsReducer } from '../restricted-words-next/restrictedWordsSlice';
import { RestrictedWordsState } from '../restricted-words-next/restrictedWordsTypes';

interface ModerationState {
  messages: IModerationMessagesState;
  users: IModerationUserState;
  posts: IModerationPostsState;
  search: IModerationSearchState;
  hotKeys: IModerationHotKeysState;
  audit: IModerationAuditLogState;
  moderatedUsers: IModeratedUsersState;
  articles: ILoadArticlesSliceState;
  restrictedWords: RestrictedWordsState;
}

export default combineReducers({
  messages,
  users,
  posts,
  search,
  hotKeys,
  audit,
  moderatedUsers,
  restrictedWords: restrictedWordsReducer,
  articles: loadArticlesReducer
});

export { ModerationState };
export * from '../comments-and-posts/state/reducers/users';
export * from '../comments-and-posts/state/reducers/posts';
export * from '../comments-and-posts/state/reducers/moderation';
export * from '../comments-and-posts/state/reducers/search';
export * from '../comments-and-posts/state/reducers/hot-keys';
export * from '../comments-and-posts/state/reducers/audit';
